import imageTesta from '../../assets/trattamenti/testa-collo.jpg';
import BackgroundImgBlur from '../../components/BackgroundImgBlur';



export default function TestaCollo() {

  const testaColloContent = <>
    <div data-aos="fade-zoom-in" data-aos-duration="1000" className={`text-lg mt-10 mb-16 text-white`} > 
        <ul className='text-left'>
            <li className="mb-5 pb-3 border-b-2 border-[#65806E] mt-8">
                <b>Dolore Cervicale Aspecifico:</b> <br /> Terapia manuale, tecar terapia, laser terapia, esercizio terapeutico.
            </li>
            <li className="mb-5 pb-3 border-b-2 border-[#65806E] mt-8">
                <b>Dolore da Ernia Cervicale:</b>  <br /> Esame neurologico di base, educazione del paziente, tecniche di terapia manuale, educazione al movimento, trattamento attivo, neurodinamica, tecar terapia, laser terapia.
            </li>
            <li className="mb-5 pb-3 border-b-2 border-[#65806E] mt-8">
                <b>Post Intervento Chirurgico:</b> Educazione del paziente, tecniche di terapia manuale, educazione al movimento, trattamento attivo, neurodinamica, tecar terapia, laser terapia.
            </li>
            <li className="mb-5 pb-3 border-b-2 border-[#65806E] mt-8">
            <b>Terapia Post Colpo di Frusta:</b>  <br /> Educazione del paziente, tecniche di terapia manuale, educazione al movimento, trattamento attivo, tecar terapia, laser terapia.
            </li>
            <li className="mb-5 pb-3 border-b-2 border-[#65806E] mt-8">
                <b>Cefalee (Primarie e Secondarie):</b>  <br /> Inquadramento della tipologia di cefalea, educazione del paziente, tecniche di terapia manuale, educazione al movimento, trattamento attivo, tecar terapia.
            </li>
            <li className="mb-5 pb-3 border-b-2 border-[#65806E] mt-8">
                <b>Quadri Vertiginosi:</b>  <br /> Inquadramento della tipologia di vertigine, consulto medico se necessario, educazione del paziente, tecniche di terapia manuale, educazione al movimento, trattamento attivo.
            </li>
            <li className="mb-3 pb-3 border-b-2 border-[#65806E] mt-8">
                <b>Problematiche Temporo-Mandibolari (ATM):</b>  <br /> Inquadramento della tipologia di disturbo, consulto medico se necessario, educazione del paziente, tecniche di terapia manuale, educazione al movimento, trattamento attivo.
            </li>
        </ul>
    </div>
  </>
  
    return <>
        <BackgroundImgBlur src={imageTesta} title={'TESTA / COLLO'} content={testaColloContent} />
    </>
    
}